<template>
    <div>
        <b-datatable
            ref="grid"
            :key="datatableKey"
            :columns="columns"
            :endpoint="listRoute"
            :hidden-columns="hiddenColumns"
            :initial-filters="initialFilters"
            :has-filters="false"
            :keep-filters="false"
        >
            <template #[`item.created_at`]="{ item }">
                {{ item.created_at ? moment(item.created_at).format($root.dateFormat) : t('default::label.na') }}
            </template>
        </b-datatable>
    </div>
</template>
<script>
export default {
    props: {
        listRoute: {
            type: String,
            required: true,
        },
        initialFilters: {
            type: Object,
            required: true,
        },
        columns: {
            type: Array,
            required: true,
        },
        hiddenColumns: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            datatableKey: 0,
            createdAtCalendar: null,
        };
    },
    computed: {
        period() {
            return this.$store.state.qualityControl.neqas.period;
        },
        filters() {
            return this.$store.state.qualityControl.neqas.filters;
        },
    },
    methods: {
        changeTab() {
            this.$refs.grid;
            if (!this.$refs.grid) {
                return;
            }
            this.$refs.grid.switchTab();
        },
    },
};
</script>
<style scoped></style>
